<div
  class="calendar-holder no-border-radius"
  *ngIf="viewModel$ | async as viewModel"
>
  <div class="calendar-header-wrapper">
    <div class="calendar-header-controls">
      <div class="header-left">
        <button
          pButton
          [outlined]="true"
          icon="pi pi-calendar"
          label="Today"
          (click)="store.dispatch(BookingScheduleActions.todayButtonClicked())"
        ></button>
        <button
          pButton
          [outlined]="true"
          icon="pi pi-chevron-left"
          (click)="store.dispatch(BookingScheduleActions.previousButtonClicked())"
        ></button>
        <button
          pButton
          [outlined]="true"
          icon="pi pi-chevron-right"
          (click)="store.dispatch(BookingScheduleActions.nextButtonClicked())"
        ></button>
      </div>

      <div class="header-center">
        <span
          class="calendar-title"
          *ngIf="viewModel.view !== 'dayGridMonth'"
          >{{ viewModel.title }}</span
        >
        <p-calendar
          *ngIf="viewModel.view === 'dayGridMonth'"
          appendTo="body"
          inputId="schedule-month-picker"
          view="month"
          dateFormat="MM yy"
          dataType="string"
          [ngModel]="viewModel.monthDate"
          (onSelect)="
            store.dispatch(
              BookingScheduleActions.monthChanged({
                date: $event,
              })
            )
          "
          [readonlyInput]="true"
          showIcon="true"
          iconDisplay="input"
          data-cy="schedule-month-picker"
        ></p-calendar>
      </div>

      <div class="header-right">
        <button
          pButton
          [outlined]="true"
          icon="pi {{
            viewModel.restrictionsDisabled ? 'pi-unlock' : 'pi-lock'
          }}"
          type="button"
          pTooltip="{{
            viewModel.restrictionsDisabled ? 'Enable' : 'Disable'
          }} Restrictions"
          tooltipPosition="bottom"
          (click)="
            store.dispatch(BookingScheduleActions.toggleRestrictionsButtonClicked())
          "
        ></button>
        <button
          pButton
          [outlined]="true"
          icon="pi pi-sliders-h"
          type="button"
          (click)="settingsPanel.toggle($event)"
          aria-label="Schedule settings"
        ></button>
        <p-overlayPanel
          #settingsPanel
          class="schedule-settings-overlay"
          appendTo="body"
        >
          <div class="settings-list">
            <div class="settings-item">
              <p-inputSwitch
                [ngModel]="!viewModel.isMonthView"
                inputId="day-view-toggle"
                (onChange)="
                  store.dispatch(BookingScheduleActions.calendarViewToggled())
                "
              ></p-inputSwitch>
              <label for="day-view-toggle" class="settings-label">
                <span>Day view</span>
              </label>
            </div>
            <div class="settings-item">
              <p-checkbox
                binary="true"
                [ngModel]="viewModel.showEventsOnMonthView"
                inputId="show-events-month-view"
                (onChange)="
                  store.dispatch(BookingScheduleActions.showEventsInputSwitched())
                "
              ></p-checkbox>
              <label for="show-events-month-view"
                >Show events on month view</label
              >
            </div>
          </div>
        </p-overlayPanel>
      </div>
    </div>
    <div class="warnings-container" *ngIf="viewModel.hasAnyWarning">
      <div
        class="p-message p-message-{{ warning.severity }} warnings-message"
        role="alert"
        *ngFor="let warning of viewModel.warnings"
      >
        <span
          class="p-message-icon pi"
          [ngClass]="
            warning.severity === 'error'
              ? 'pi-times-circle'
              : 'pi-exclamation-triangle'
          "
        ></span>
        <div class="p-message-text">
          <ng-container [ngSwitch]="warning.type">
            <span *ngSwitchCase="'missingLocations'" class="warning-text-only">
              Missing Locations:
              <span class="missing-locations-list">
                {{ warning.missingLocations | join }}
              </span>
            </span>
            <span *ngSwitchCase="'timeNotAvailable'" class="warning-text-only">
              Start time is not available anymore. Please select another time.
            </span>
            <span
              *ngSwitchCase="'assetsNotAvailable'"
              class="warning-text-only"
            >
              Selected assets are not available for selected time. Please select
              another time or another asset
            </span>
            <span *ngSwitchCase="'noAvailability'" class="warning-with-action">
              <span>No availability on this date</span>
              <button
                pButton
                type="button"
                class="p-button-danger"
                icon="pi pi-lock"
                label="Override Scheduling Restrictions"
                (click)="
                  store.dispatch(
                    BookingScheduleActions.overrideSchedulingRestrictionsButtonClicked()
                  )
                "
              ></button>
            </span>
            <span
              *ngSwitchCase="'restrictionsDisabled'"
              class="warning-with-action"
            >
              <span>
                Restrictions disabled. Double-check to avoid overbooking.
              </span>
              <button
                pButton
                type="button"
                class="p-button-warning"
                [outlined]="true"
                icon="pi pi-lock"
                label="Re-enable Restrictions"
                (click)="
                  store.dispatch(
                    BookingScheduleActions.enableSchedulingRestrictionsButtonClicked()
                  )
                "
              ></button>
            </span>
            <span *ngSwitchCase="'depositRequired'" class="warning-with-action">
              <span>
                A deposit of
                {{ warning.amount | freyaCurrency: viewModel.job.currency }}
                is required to book this event.
              </span>
              <button
                pButton
                type="button"
                class="p-button-danger"
                icon="pi pi-credit-card"
                label="Pay"
                (click)="store.dispatch(BookingScheduleActions.payButtonClicked())"
              ></button>
            </span>
            <span *ngSwitchDefault class="warning-text-only">
              {{ warning.text }}
            </span>
          </ng-container>
        </div>
      </div>
    </div>
    <div
      *ngFor="let remark of viewModel.dateRemarks"
      class="p-message p-message-{{ remark.severity }} remark-container"
      role="alert"
    >
      <span
        class="p-message-icon pi"
        [ngClass]="{
          'pi-info-circle': remark.severity === 'info',
          'pi-check-circle': remark.severity === 'success',
          'pi-times-circle': remark.severity === 'error',
          'pi-exclamation-triangle': remark.severity === 'warn'
        }"
      ></span>
      <div class="p-message-text">{{ remark.date }}: {{ remark.text }}</div>
    </div>
  </div>

  <p-blockUI
    [target]="calendarBlockable"
    [blocked]="viewModel.scheduleLoading"
    [autoZIndex]="false"
  >
    <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
  </p-blockUI>
  <app-blockable #calendarBlockable>
    <div class="calendar-holder" style="position: relative">
      <full-calendar [options]="calendarOptions" #fc></full-calendar>
    </div>
  </app-blockable>
</div>
